export const endpoint = {
	base: "",
} as const;
